/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation } from '@apollo/react-hooks';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import ScreenLoader from 'src/components/ScreenLoader';
import { reducerSignIn } from 'src/features/users';
import { useAlert } from 'src/hooks/useAlert';
import { SETTINGS, SOCIAL_MEDIA_CONTENT, USERS_SIGN_IN } from 'src/route';
import {
  AUTO_SIGN_IN,
  CHECK_EMAIL_REGISTERED
} from 'src/services/graphql/users/mutation';

interface ICheckEmailRegisteredPayload {
  key: string;
  projectId: string;
}

const LoadingProcess: React.FC = () => {
  const { search } = useLocation();
  const isAuthenticated = useAppSelector(
    (state) => state.users.isAuthenticated
  );
  const navigate = useNavigate();
  const { handleClickAlert } = useAlert();
  const dispatch = useAppDispatch();
  const params = new URLSearchParams(search);
  const process = params.get('process');
  const key = params.get('key');
  const projectId = params.get('projectId');
  const path = params.get('path');

  const [postCheckEmailRegistered] = useMutation<
    any,
    ICheckEmailRegisteredPayload
  >(CHECK_EMAIL_REGISTERED, {
    onCompleted: (data) => {
      const url = data.user_checkEmailRegistered?.url;
      const path = url.split('/').slice(3).join('/');
      navigate(`/${path}`);
    }
  });

  const [autoLogin] = useMutation(AUTO_SIGN_IN, {
    onCompleted: ({ session }) => {
      if (!session) return;
      const isAuth = session.token ? true : false;
      window.localStorage.setItem('token', session.token);
      dispatch(reducerSignIn(isAuth));
      window.location.assign(SOCIAL_MEDIA_CONTENT);
    }
  });

  useEffect(() => {
    switch (process) {
      case 'invitation':
        postCheckEmailRegistered({
          variables: { key: key, projectId: projectId }
        });
        break;
      case 'alert-system':
        if (isAuthenticated) {
          if (!path || !projectId) return;
          window.localStorage.setItem('project', projectId);
          window.location.assign(path);
        } else {
          window.location.assign(
            `${USERS_SIGN_IN}?projectId=${projectId}&path=${path}`
          );
        }
        break;
      case 'auto-login':
        if (isAuthenticated) {
          window.location.assign(SOCIAL_MEDIA_CONTENT);
        } else {
          autoLogin({
            variables: { key }
          });
        }
        break;
      case 'stream-payment-success':
        window.location.assign(`${SETTINGS}?tab=billing`);
        handleClickAlert({
          horizontal: 'center',
          vertical: 'top',
          message: 'Upgrade stream is success!',
          severity: 'success'
        });
        break;
    }
  }, []);

  return <ScreenLoader />;
};

export default LoadingProcess;
